import React from 'react';
import { AllieChip, AllieChipType } from '../../../Chip';
import { DataGridCellBaseProps } from '../../DataGridCell.types';

export type DataGridTagCellProps = { colorType?: Record<string, AllieChipType> | AllieChipType, fontSize: number | string };
export const DataGridTagCell: React.FC<
  DataGridCellBaseProps<string, DataGridTagCellProps>
> = ({ value, cellProps: { colorType = 'primary', fontSize = 'inherit' } }) => {
  return <AllieChip style={{ fontSize }} allieType={ typeof colorType === 'string' ? colorType : colorType[value] }>{value}</AllieChip>;
};
